(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      // Commented AS OF ( February 28 2023 )
      // this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {

      // OLD SCRIPT AS OF (  January 27 2023)
      // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      //   if (this.preventHide) return;
      //   requestAnimationFrame(this.hide.bind(this));
      // } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      //   if (!this.preventReveal) {
      //     requestAnimationFrame(this.reveal.bind(this));
      //   } 
      //   else {
      //     window.clearTimeout(this.isScrolling);

      //     this.isScrolling = setTimeout(() => {
      //       this.preventReveal = false;
      //     }, 66);

      //     requestAnimationFrame(this.hide.bind(this));
      //   }
      // } else if (scrollTop <= this.headerBounds.top) {
      //   requestAnimationFrame(this.reset.bind(this));
      // }
      // this.currentScrollTop = scrollTop;

      // NEW SCRIPT AS OF ( January 28 2023 )
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      scrollTop < 0 ? scrollTop = 0 : ''  
      
      if (scrollTop > this.currentScrollTop) {
        jQuery('.header-wrapper').fadeOut();
        document.querySelector('.header-wrapper').style.position = 'none'
        // requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop) {
        jQuery('.header-wrapper').fadeIn(); 
        document.querySelector('.header-wrapper').style.position = 'fixed'
        document.querySelector('.header-wrapper').style.width = '100%'
        // requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop == 0 ) {
        document.querySelector('.header-wrapper').removeAttribute('style')
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#home_bnn__vd.video_container__');
  const mbl_cont = document.querySelector('#mbl_player');
  const controller_player = vd_cont?.querySelector('.video_plyr__');
  const mobile_player = mbl_cont?.querySelector('.video_plyr__');
  const vd = vd_cont?.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    console.log('clicked');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd)
      vd.play();
    } else {
      vd.pause();
    }
  })
  mobile_player && mobile_player.addEventListener('click', () => {
    console.log('clicked');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd)
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause');
  })
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play');
  })
  
  vd && vd.addEventListener("fullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-post-1-a"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#vd_bnn__vd_1.video_container__');
  const controller_player = vd_cont.querySelector('.video_plyr__ span');
  const vd = vd_cont.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    console.log('clicked');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd);
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause')
  });
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play')
  });
  
  vd && vd.addEventListener("fullscreenchange", function(event) {
    console.log('change made')
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-post-1"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#vd_bnn__vd_1.video_container__');
  const controller_player = vd_cont.querySelector('.video_plyr__');
  const vd = vd_cont.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    console.log('clicked__');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd);
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause')
  });
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play')
  });
  
  vd && vd.addEventListener("fullscreenchange", function(event) {
    console.log('change made')
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-post-2"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#vd_bnn__vd_2.video_container__');
  const controller_player = vd_cont.querySelector('.video_plyr__ span');
  const vd = vd_cont.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    console.log('clicked');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd);
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause')
  });
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play')
  });
  
  vd && vd.addEventListener("fullscreenchange", function(event) {
    console.log('change made')
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-post-bottle"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#vd_bnn__vd_1.video_container__');
  const controller_player = vd_cont.querySelector('.video_plyr__ span');
  const vd = vd_cont.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    console.log('clicked');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd);
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause')
  });
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play')
  });
  
  vd && vd.addEventListener("fullscreenchange", function(event) {
    console.log('change made')
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-post-concentration-test"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#vd_bnn__vd_1a.video_container__');
  const controller_player = vd_cont.querySelector('.video_plyr__');
  const vd = vd_cont.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    console.log('clicked__');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd);
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause')
  });
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play')
  });
  
  vd && vd.addEventListener("fullscreenchange1a", function(event) {
    console.log('change made')
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchange1a", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchange1a", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchange1a", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-post-hydrogen-concentration-test"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#vd_bnn__vd_2_.video_container__');
  const controller_player = vd_cont.querySelector('.video_plyr__ span');
  const vd = vd_cont.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    console.log('clicked');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd);
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause')
  });
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play')
  });
  
  vd && vd.addEventListener("fullscreenchange", function(event) {
    console.log('change made')
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-post-installation"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#vd_bnn__vd_2.video_container__');
  const controller_player = vd_cont.querySelector('.video_plyr__ span');
  const vd = vd_cont.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    console.log('clicked');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd);
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause')
  });
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play')
  });
  
  vd && vd.addEventListener("fullscreenchange", function(event) {
    console.log('change made')
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-post-two-bottle-d"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#vd_bnn__vd_1d.video_c_container__');
  const controller_player = vd_cont.querySelector('.video_plyr__');
  const vd = vd_cont.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    console.log('clicked__');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd);
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause')
  });
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play')
  });
  
  vd && vd.addEventListener("fullscreenchanges2", function(event) {
    console.log('change made')
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchanges2", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchanges2", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchanges2", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-post-two-bottle"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#vd_bnn__vd_1c.video_c_container__');
  const controller_player = vd_cont.querySelector('.video_plyr__');
  const vd = vd_cont.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    console.log('clicked__');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd);
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause')
  });
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play')
  });
  
  vd && vd.addEventListener("fullscreenchanges", function(event) {
    console.log('change made')
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchanges", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchanges", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchanges", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-post-two-bottles"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#vd_bnn__vd_1.video_container__');
  const controller_player = vd_cont.querySelector('.video_plyr__ span');
  const vd = vd_cont.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    console.log('clicked');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd);
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause')
  });
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play')
  });
  
  vd && vd.addEventListener("fullscreenchange", function(event) {
    console.log('change made')
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-post-upload"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#vd_bnn__vd_2.video_container__');
  const controller_player = vd_cont.querySelector('.video_plyr__ span');
  const vd = vd_cont.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    console.log('clicked');
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd);
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause')
  });
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play')
  });
  
  vd && vd.addEventListener("fullscreenchange", function(event) {
    console.log('change made')
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-post"] && !window.DesignMode) return;
  try {
    
  function openFullscreen(elem) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem = window.top.document.body;
      elem.msRequestFullscreen();
    }
  }
  const vd_cont = document.querySelector('#vd_bnn__vd.video_container__');
  const controller_player = vd_cont?.querySelector('.video_plyr__');
  const vd = vd_cont?.querySelector('video');
  controller_player && controller_player.addEventListener('click', () => {
    if (!vd) {
      return;
    }
    if (vd.paused) {
      openFullscreen(vd);
      vd.play();
    } else {
      vd.pause();
    }
  })
  vd && vd.addEventListener('pause', () => {
    vd_cont.setAttribute('data-state', 'pause')
  });
  vd && vd.addEventListener('play', () => {
    vd_cont.setAttribute('data-state', 'play')
  });
  
  vd && vd.addEventListener("fullscreenchange", function(event) {
    console.log('change made')
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("mozfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("webkitfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });
  
  vd && vd.addEventListener("msfullscreenchange", function(event) {
    if (!document.fullscreenElement) {
      vd.pause();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
